import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=031d25b8&"
import script from "./CampaignDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=031d25b8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031d25b8')) {
      api.createRecord('031d25b8', component.options)
    } else {
      api.reload('031d25b8', component.options)
    }
    module.hot.accept("./CampaignDetails.vue?vue&type=template&id=031d25b8&", function () {
      api.rerender('031d25b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/ViewCampaign/CampaignDetails.vue"
export default component.exports